module.exports = __webpack_public_path__ + "img/90sheji_linggan_13648589@2x.b4206563.png";